import React, { useEffect, useState } from 'react'
import { AppInput, InputMaskType } from '../../../components/AppInput/AppInput'
import { customSortForOrderLine } from '../CreatePlanMenuPage'
import { getTimeFromMins } from 'utils/formatDate'
import { AppTableImageViewer } from '../../../components/AppTableImageViewer/AppTableImageViewer'
import { AppTable } from '../../../components/AppTable/AppTable'
import { IOrderLine } from '../../../core/api/dto/PlanMenuDto'
import { ImagePreviewWrapperSizeEnum } from 'shared/ui/ImagePreviewWrapper/ImagePreviewWrapper'
import { AppTableNumberBlock } from '../../../components/AppTable/components/AppTableNumberBlock'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

const headerData = [
  { title: 'Наименование', colWidth: '20%', sort: 'name' },
  { title: 'Категория блюда', colWidth: '20%', sort: 'category' },
  {
    title: 'Заявка, согласно план-меню, кг',
    colWidth: '20%',
    sort: 'quantity',
  },
  { title: 'Вес эталонный, кг', colWidth: '10%', sort: 'standard_weight' },
  {
    title: 'Температура эталонная, °C',
    colWidth: '10%',
    sort: 'standard_temp',
  },
  {
    title: 'Время реализации, ч:мин',
    colWidth: '10%',
    sort: 'implementation_period',
  },
  { title: 'Эталонное фото', colWidth: '5%' },
]

interface IPlanMenuTableDishProps {
  planMenuTableData: IOrderLine[]
  setPlanMenuTableData: React.Dispatch<React.SetStateAction<IOrderLine[]>>
  tableActionsProps: {
    title: string
    ico: string
    onClick: () => void
    disabled?: boolean
  }[]
  tableValid: boolean
  setIsDirty?: (value: boolean) => void
  chooseItems: IChooseItems | null
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>
  isDisabled?: boolean
}

export const PlanMenuTableDish = ({
  planMenuTableData,
  tableActionsProps,
  tableValid,
  setPlanMenuTableData,
  chooseItems,
  setChooseItems,
  setIsDirty,
  isDisabled,
}: IPlanMenuTableDishProps) => {
  const [currentSortValue, setCurrentSortValue] = useState<null | string>(null)

  const changeQuantityHandler = (id: number, value: string) => {
    const newPlanMenuTableData: IOrderLine[] = planMenuTableData.map((item) =>
      item.id === id ? { ...item, weightOfDish: value } : item,
    )
    setPlanMenuTableData(newPlanMenuTableData)
    setIsDirty && setIsDirty(true)
  }

  const blurQuantityHandler = (id: number) => {
    const newPlanMenuTableData: IOrderLine[] = planMenuTableData.map(
      (item) =>
        item.id === id
          ? {
              ...item,
              quantity: Number(item.weightOfDish).toFixed(3),
            }
          : item,
      12,
    )
    setPlanMenuTableData(newPlanMenuTableData)
  }
  const onDeleteOrderLine = () => {
    if (chooseItems) {
      setPlanMenuTableData((planMenuTableData) =>
        planMenuTableData.filter((item) => !chooseItems[item.id]),
      )
      setIsDirty && setIsDirty(true)
    }

    setChooseItems(null)
  }

  useEffect(() => {
    if (currentSortValue) {
      customSortForOrderLine(currentSortValue, setPlanMenuTableData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSortValue])

  const tableActions = [
    {
      title: 'Удалить',
      ico: 'basket',
      onClick: onDeleteOrderLine,
    },
    ...tableActionsProps,
  ]

  return (
    <AppTable
      data={{
        count: 0,
        next: '',
        results: [...planMenuTableData].sort((a, b) => {
          if (isDisabled) {
            return a.dish.isArchived > b.dish.isArchived ? 1 : -1
          } else {
            return a.dish.isArchived > b.dish.isArchived ? -1 : 1
          }
        }),
        previous: '',
      }}
      withoutPagination
      bigPaddingBottom={!tableValid}
      headerData={headerData}
      chooseMode={!isDisabled}
      idName="plan-menu-create"
      chooseItems={!isDisabled ? chooseItems : undefined}
      setChooseItems={!isDisabled ? setChooseItems : undefined}
      chooseActions={!isDisabled ? tableActions : undefined}
      setCurrentSortFn={setCurrentSortValue}
      tableDataSelectors={[
        {
          renderItem: (item) => (
            <div className={item.dish.isArchived ? 'delete-item' : undefined}>
              {item.dish.name}
            </div>
          ),
        },
        {
          renderItem: (item) => (
            <div className={item.dish.isArchived ? 'delete-item' : undefined}>
              {item.dish?.internalDishCategory?.name}
            </div>
          ),
        },
        {
          renderItem: (item) => (
            <AppInput
              value={`${item.weightOfDish}`}
              onChange={(value) => changeQuantityHandler(item.id, value)}
              border
              inputMask={InputMaskType.float}
              onBlur={() => {
                blurQuantityHandler(item.id)
                customSortForOrderLine(currentSortValue, setPlanMenuTableData)
              }}
              error={
                !tableValid &&
                (!item.weightOfDish || Number(item.weightOfDish) === 0)
                  ? 'Обязательное поле'
                  : null
              }
              disabled={item.dish.isArchived}
            />
          ),
        },
        {
          renderItem: (item) => (
            <div
              className={`text-end ${
                item.dish.isArchived ? 'delete-item' : undefined
              }`}
            >
              <AppTableNumberBlock
                value={
                  item?.dish?.standardWeight
                    ?.toFixed(3)
                    .toString()
                    .replace(/[.]/g, ',') || ''
                }
              />
            </div>
          ),
        },
        {
          renderItem: (item) => (
            <div
              className={`text-end ${
                item.dish.isArchived ? 'delete-item' : undefined
              }`}
            >
              <AppTableNumberBlock
                isTemp
                value={item.dish.standardTempMin ?? ''}
              />{' '}
              <span className="pl-4 pr-4"> - </span>
              <AppTableNumberBlock
                isTemp
                value={item.dish.standardTempMax ?? ''}
              />
            </div>
          ),
        },
        {
          renderItem: (item) => (
            <div className={item.dish.isArchived ? 'delete-item' : undefined}>
              {`${
                !!item.dish.implementationPeriod
                  ? getTimeFromMins(item.dish.implementationPeriod)
                  : ''
              }`}
            </div>
          ),
        },
        {
          renderItem: (item) => (
            <AppTableImageViewer
              imgPreview={item.dish.imagePreviewOnS3 || item.dish.imagePreview}
              image={item.dish.imageOnS3 || item.dish.image}
              imageName={item.dish.name}
              archived={item.dish.isArchived}
              size={ImagePreviewWrapperSizeEnum.MEDIUM}
            />
          ),
        },
      ]}
    />
  )
}
